import * as L from 'leaflet';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from '../../providers/base.service';

// A map control with a search box: the places the API finds near the map centre
// (api/map_search) are listed under it, and picking one centres the map there.
// The wireless and dedicate-location maps keep their pin on the centre, so this
// moves the pin.
export function addSearchControl(map: L.Map, translator: TranslateService, service: BaseService): L.Control {
  const search = async (term: string): Promise<any[]> => {
    if (term.length <= 3) {
      return [];
    }
    try {
      const result = await service.apiCall('api/map_search', { term, center: map.getCenter() }).toPromise();
      return result.count ? result.items.map(r => ({ name: `${r.title} (${r.neighbourhood || ''} ${r.region})`, latitude: r.location.y, longitude: r.location.x })) : [];
    } catch (error) {
      console.error('Error fetching search results:', error);
      return [];
    }
  };

  const SearchControl = L.Control.extend({
    options: {
      position: 'topright'
    },
    onAdd: () => {
      const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom samim');
      container.style.backgroundColor = 'white';
      container.style.padding = '5px';
      container.style.borderRadius = '5px';

      const input = L.DomUtil.create('input', '', container);
      input.type = 'text';
      input.placeholder = translator.instant('SEARCH');
      input.style.width = '200px';
      input.style.fontSize = 'larger';
      input.style.border = 'none';
      input.style.outline = 'none';

      const resultsContainer = L.DomUtil.create('ul', 'search-results', container);
      resultsContainer.style.listStyle = 'none';
      resultsContainer.style.margin = '0';
      resultsContainer.style.padding = '0';
      resultsContainer.style.maxHeight = '300px';
      resultsContainer.style.overflowY = 'auto';
      resultsContainer.style.backgroundColor = 'white';
      resultsContainer.style.border = '1px solid #ccc';
      resultsContainer.style.display = 'none'; // until there are results

      // Scrolling the list must not zoom the map under it
      L.DomEvent.on(resultsContainer, 'mouseover', () => {
        map.scrollWheelZoom.disable();
      });
      L.DomEvent.on(resultsContainer, 'mouseout', () => {
        map.scrollWheelZoom.enable();
      });

      L.DomEvent.on(input, 'input', async () => {
        const results = await search(input.value.trim());
        resultsContainer.innerHTML = '';
        resultsContainer.style.display = results.length ? 'block' : 'none';
        results.forEach(result => {
          const resultItem = L.DomUtil.create('li', '', resultsContainer);
          resultItem.textContent = result.name;
          resultItem.style.fontSize = 'larger';
          resultItem.style.padding = '5px';
          resultItem.style.cursor = 'pointer';
          resultItem.style.borderBottom = '1px solid #eee';

          resultItem.addEventListener('mouseover', () => {
            resultItem.style.backgroundColor = '#f0f0f0';
          });
          resultItem.addEventListener('mouseout', () => {
            resultItem.style.backgroundColor = 'white';
          });

          L.DomEvent.on(resultItem, 'click', () => {
            map.setView(L.latLng(result.latitude, result.longitude), 18);
            resultsContainer.style.display = 'none';
          });
        });
      });

      // Typing and clicking here must not reach the map
      L.DomEvent.disableClickPropagation(container);

      return container;
    }
  });

  const control = new SearchControl();
  map.addControl(control);
  return control;
}
